import * as React from 'react';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useCookies} from "react-cookie";

export default function LogoutWarningDialog({isOpen, handleClose, handleLogout, handleTimeout, countdownSeconds}) {
    const [secondsRemaining, setSecondsRemaining] = React.useState(countdownSeconds);

    useEffect(() => {
        let timer;
        if (isOpen) {
            setSecondsRemaining(countdownSeconds);
            timer = setInterval(() => {
                setSecondsRemaining((prevSeconds) => {
                    if (prevSeconds >= 1) {
                        return prevSeconds - 1;
                    } else {
                        clearInterval(timer);
                        handleTimeout(); // Trigger the timeout-specific logout
                        return 0;
                    }
                });
            }, 1000);
        }
        return () => clearInterval(timer);
    }, [isOpen, countdownSeconds, handleTimeout]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };

    return (
        <div>
            <DialogTitle>{"Abmelden abbrechen?"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    Sie waren für längere Zeit inaktiv.
                    Zu Ihrer Sicherheit werden Sie in {formatTime(secondsRemaining)} automatisch abgemeldet.
                    Schließen Sie dieses Fenster, um die Zeit zu verlängern
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleLogout} color="error">
                    Jetzt abmelden
                </Button>
                <Button onClick={handleClose} variant="contained">
                    Angemeldet bleiben
                </Button>
            </DialogActions>
        </div>
    );
}